import { createMuiTheme } from "@material-ui/core/styles";
import { generateMedia } from "styled-media-query";

export const media = generateMedia({
  xs: "320px",
  sm: "600px",
  md: "768px",
  lg: "1280px",
  xl: "1920px",
});

const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 320,
      sm: 600, // Mobile
      md: 768, // Tablet
      lg: 1280, // Desktop
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: "#0A1F44",
    },
    secondary: {
      main: "#2F80ED",
    },
    action: {
      main: "#2F80ED",
    },
    text: {
      primary: "#0A1F44",
      secondary: "#53627C",
    },
    background: {
      paper: "#FFFFFF",
      default: "#FBFBFB",
    },
  },
  action: {
    focus: "#2F80ED",
  },
  typography: {
    fontFamily: ["'Open sans'", "Arial", "sans-serif"].join(", "),
    fontSize: 14,
    caption: {
      fontSize: 12,
    },
    subtitle2: {
      fontSize: "12px",
    },
    button: {
      textTransform: "capitalize",
    },
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: "#FFF",
      },
    },
    MuiRadio: {
      root: {
        color: "#C9CED6",
      },
    },
    subtitle1: {
      fontSize: 18,
      fontWeight: "semibold",
    },
  },
});

export default theme;
